import {ComponentType, FC} from "react";

export function createHOC<OriginalProps, ExtendedProps>(
    hocName: string,
    logic: (WrappedComponent: FC<OriginalProps>) => FC<ExtendedProps>
): (WrappedComponent: FC<OriginalProps>) => FC<ExtendedProps> {

    return (WrappedComponent: FC<OriginalProps>) => {
        const HOC = logic(WrappedComponent);

        HOC.displayName = `${hocName}(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

        return HOC;
    };
}
